import React from 'react'

import { SidebarPanel } from '../components/SidebarPanel'
import { ResourceSectionList } from '../ResourceSectionList'

const WhatsNew = ({ header, sections }) => {
  if (!sections || !sections.length) return null

  return (
    <SidebarPanel header={header}>
      <ResourceSectionList sections={sections} />
    </SidebarPanel>
  )
}

WhatsNew.propTypes = {
  header: React.PropTypes.string,
  sections: React.PropTypes.array
}

export default WhatsNew
